import React, {useState, useEffect, useContext} from 'react';
import { Box, Typography, Modal, Button, Alert } from '@mui/material';
import InvestigationExtraQuestionsForm from './investigationextraquestionsform';
import investigationExtraQuestions from '../../../utilities/investigations/investigationextraquestions';
import investigationNameSimplifier from '../../../utilities/investigations/investigationnamesimplifier';
import { SymptomDetailsContext } from '../../../utilities/context.js'


function InvestigationExtraQuestionsModal (props){

  const [questions, setQuestions] = useState()
  const [investigationsForQuestions, setInvestigationsForQuestions] = useState(props.investigationsForQuestions)
  const [submitted, setSubmitted] =useState(false)
  const [alertNotSubmitted, setAlertNotSubmitted]= useState(false)
  const {setIxList} = useContext(SymptomDetailsContext) 

const style={
    position: 'absolute',
    top: '50%',
    left: {xs:"37%", sm:"30%"},
    transform: 'translate(-30%, -50%)',
    flex: {xs:"50%", sm:"90%"},
    display:"flex block",
    maxHeight:"90%",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    overflow:"scroll"
    };

    useEffect(()=>setInvestigationsForQuestions(props.investigationsForQuestions),[props.investigationsForQuestions])

    useEffect(()=>
    {
    let questionList=[]
    if (investigationsForQuestions.length>0)
      {
      investigationsForQuestions.forEach((element) =>
        { 
        if (investigationNameSimplifier.hasOwnProperty(element))// replaces Ix name with simpler form to avoid duplication
          {
          element = investigationNameSimplifier[element]
          }
        if (investigationExtraQuestions.hasOwnProperty(element))
            {
            let investigationQuestions=[]
              investigationQuestions.push(...investigationExtraQuestions[element])
              investigationQuestions.forEach((question)=>{
              if (!questionList.some((existingQuestion)=>{return(question["label"]===existingQuestion["label"])}))
                {
                  questionList.push(question)
                }
            })
          }
          })
        }
        setQuestions(questionList)
    },[investigationsForQuestions])

      useEffect(()=>{
        if (questions && questions.length>0)
        {props.setModalOpen(true)
        }
        else 
          {props.setModalOpen(false)}
      },[questions])


const handleClose=()=>{
  if (submitted)
    {
    props.setModalOpen(false)
    }
  else
    {
     setAlertNotSubmitted(true) //prevents closing form without submitting questions and keeping investigtions
    }
  }
  
  useEffect(()=>{
    if(submitted)
    {
      props.setModalOpen(false)
    }
  },[submitted])//needed becuase closure on handleClose prevents modal closing if correct submit carried out

const removeInvestigations=()=>
  {
  setIxList([])
  setAlertNotSubmitted(false)
  props.setModalOpen(false)
  }

const output=<InvestigationExtraQuestionsForm  questions={questions} handleClose={handleClose} setSubmitted={setSubmitted}/> 

return(
<Modal
  open={props.modalOpen}
  onClose={handleClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box sx={style}>
    <Typography id="modal-modal-title" variant="h6" component="h2">
      Required Information for the Investigations you have requested
    </Typography>
    <br></br>
   <Box sx={{m:2}}>
    {output}
  </Box>
  {alertNotSubmitted && <Alert severity='warning'> You are trying to close the form without submitting it. If you do this, none of your investigation orders will be saved. <Button variant='outlined' onClick={removeInvestigations}>Ignore warning</Button></Alert>}
  </Box>
</Modal>)

}

export default InvestigationExtraQuestionsModal